// cleanup_convert_to_typescript_file_PYMTLSTVIEW

/* eslint-disable import/prefer-default-export */
export const PAYMENTS_GRID_NAME = 'payments';
export const SMALL_BUSINESS_GRID_NAME = 'small-business-payments';
export const TRANSFERS_GRID_NAME = 'transfers';

export const PAYMENTS_COLUMNS = {
  accountType: 'accountType',
  achReceiver: 'achReceiver',
  activated: 'activated',
  activationUser: 'activationUser',
  addendum: 'addendum',
  amount: 'amount',
  approvalDate: 'approvalDate',
  approvalUser: 'approvalUser',
  approvedOn: 'approvedOn',
  approver: 'approver',
  bankTrace: 'bankTrace',
  beneficiary: 'beneficiary',
  beneficiaryAccount: 'beneficiaryAccount',
  beneficiaryAccountNumber: 'beneficiaryAccountNumber',
  beneficiaryBankRoutingNumber: 'beneficiaryBankRoutingNumber',
  beneficiaryId: 'beneficiaryId',
  beneficiaryBank: 'beneficiaryBank',
  comments: 'comments',
  companyEntryDescription: 'companyEntryDescription',
  companyId: 'companyId',
  companyName: 'companyName',
  confirmationInfo: 'confirmationInfo',
  currency: 'currency',
  custTrace: 'custTrace',
  date: 'date',
  debitAmount: 'debitAmount',
  effectiveEntryDate: 'effectiveEntryDate',
  exchangeRate: 'exchangeRate',
  fromAccount: 'fromAccount',
  fromAccountName: 'fromAccountName',
  fromAccountNumber: 'fromAccountNumber',
  id: 'id',
  individualEntryState: 'individualEntryState',
  individualIdNumber: 'individualIdNumber',
  initiatedOn: 'initiatedOn',
  initiator: 'initiator',
  itemCount: 'itemCount',
  memo: 'memo',
  name: 'name',
  newTransactionDt: 'newTransactionDt',
  noteNumber: 'noteNumber',
  numCredits: 'totalCredits',
  numDebits: 'totalDebits',
  payeeName: 'payeeName',
  paymentCategory: 'paymentCategory',
  paymentEntryMethod: 'paymentEntryMethod',
  paymentType: 'paymentType',
  possibleActions: 'possibleActions',
  remainingApproval: 'remainingApproval',
  sameDay: 'sameDay',
  status: 'status',
  selector: 'selector',
  templateName: 'templateName',
  totalCredits: 'totalCredits',
  totalDebits: 'totalDebits',
  transactionDate: 'transactionDate',
  transactionDt: 'transactionDt',
  transactionType: 'transactionType',
  uniqueId: 'uniqueId',
  wireEntryDate: 'wireEntryDate',
  wirePaymentStatus: 'wirePaymentStatus',
  wireType: 'wireType'
};

export const PAYMENTS_CONFIRMATION_STATUSES = {
  acknowledged: 'Acknowledged',
  financialInstitutionRejected: 'Financial Institution Rejected'
};

export const PAYMENT_MASKED_STORED = 'paymentMasked';

// Note: these are used to preselect wire/loan options on create-payment page
export const PAYMENT_PRESELECTS = {
  DRAWS: [{ id: '115', name: 'Loan Draw', type: 'DRAWS' }],
  Domestic: [{ id: '101', name: 'Domestic Wire', type: 'Domestic' }],
  International: [{ id: '102', name: 'International Wire', type: 'International' }],
  PAYMENTS: [{ id: '114', name: 'Loan Payment', parentName: 'Loan' }]
};
